import { crmApi } from '@/api'
import { isError } from '@/helpers/checkQuery'
import { getLeadFieldValue } from '@pages/Admin/CRM/utils/leadFields'
import { Modal as AntdModal } from 'antd'
import jclasses from '@pages/Admin/CRM/styles/jsmodal.module.css'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import { Lead } from '@/api/types/crm.types'

interface HandlerDeleteStudAccountParams {
  lead: Lead
  addAlert: (data: any) => void
  onSuccess: () => void
}

export const handlerDeleteStudAccount = ({
  lead,
  addAlert,
  onSuccess,
}: HandlerDeleteStudAccountParams) => {
  AntdModal.confirm({
    title: 'Вы уверены что хотите удалить личный кабинет студента?',
    content: getLeadFieldValue(lead, 'NAME'),
    icon: null,
    centered: true,
    maskClosable: true,
    className: jclasses.modal,
    okText: 'Подтвердить',
    cancelText: 'Отменить',
    onOk: async () => {
      await crmApi
        .deleteStudAccount({ lead_id: lead?.id! })
        .then((res) => {
          if (isError(res)) throw new Error()

          addAlert({
            title: 'Успешно',
            text: 'Личный кабинет студента успешно удален',
            type: 'success',
          })
          onSuccess()
        })
        .catch(() => {
          addAlert({
            title: 'Ошибка',
            text: 'Не удалось удалить личный кабинет студента',
            type: 'error',
          })
        })
    },
  })
}